interface SectionLabelProps {
  index: string;
  label: string;
  className?: string;
}

export default function SectionLabel({ index, label, className = '' }: SectionLabelProps) {
  return (
    <div className={`flex items-center gap-4 border-t border-background-200 pt-4 font-label text-[11px] uppercase tracking-[0.14em] text-foreground-700 md:text-xs ${className}`}>
      <span className="text-primary-500">{index}</span>
      <span>/</span>
      <span>{label}</span>
    </div>
  );
}